import Reports from "../components/Reports/Reports.vue";

let routes = {
    path: "/reports",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/reports",
            name: "Relatórios",
            component: Reports
        },
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/reports.js